import React from 'react';
import 'datatables.net'; // Import DataTables

const ComingSooon = () => {

    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div ClassName="col-sm-12">
                            <div ClassName="card soon-card">
                                <div ClassName="card-body">
                                    <h2 ClassName="mt-4 text-center f-46"><b>Coming Soon</b></h2>
                                    <p ClassName="mt-3 mb-4 text-center text-muted f-16">Something new is on it's way</p>
                                    {/* <div ClassName="soon-image-block">
                                        <img ClassName="image-animated img-fluid" src="/assets/images/pages/img-maintenance-bg.svg" alt="image" />
                                        <img src="/assets/images/pages/img-soon-box.svg" ClassName="img-soon soon-box" alt="image" />
                                        <img src="/assets/images/pages/img-soon-widget-secondary.svg" ClassName="img-soon soon-secondary" alt="image" />
                                        <img src="/assets/images/pages/img-soon-widget-primary.svg" ClassName="img-soon soon-primary" alt="image" />
                                    </div>
                                    <div ClassName="row timer-block mt-4 justify-content-center" id="timer-block">
                                        <div ClassName="col-auto">
                                            <span ClassName="avtar bg-light-secondary avtar-xl">1</span>
                                        </div>
                                        <div ClassName="col-auto">
                                            <span ClassName="avtar bg-light-secondary avtar-xl">23</span>
                                        </div>
                                        <div ClassName="col-auto">
                                            <span ClassName="avtar bg-light-secondary avtar-xl">58</span>
                                        </div>
                                        <div ClassName="col-auto"><span ClassName="avtar bg-light-secondary avtar-xl">23</span></div>
                                    </div>
                                    <div ClassName="row justify-content-center">
                                        <div ClassName="col-md-6"><div ClassName="row d-flex mt-4"><div ClassName="col">

                                        </div><div ClassName="col-auto"><div ClassName="d-grid"><button ClassName="btn d-flex align-items-center btn-primary"><i ClassName="ti ti-bell-ringing mx-1"></i> Notify Me</button></div></div></div></div></div> */}
                                        </div></div></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComingSooon;
